// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCreatePrescriberResultModel {
    static getAttributeTypeMap() {
        return EnrollmentCreatePrescriberResultModel.attributeTypeMap;
    }
}
EnrollmentCreatePrescriberResultModel.discriminator = undefined;
EnrollmentCreatePrescriberResultModel.additionalProperties = false;
EnrollmentCreatePrescriberResultModel.attributeTypeMap = [
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentCreatePrescriberResultModel.js.map